import { makeStyles } from '@mui/styles';
import { styles } from '../patient-overview-styles';
import arborTheme from '../../../../lib/themes/arbor-theme-index';
import darkTheme from '../../../../lib/themes/arbor-theme-index';
import { isLightTheme } from '../../../../lib/themes/theme';

const currentTheme = isLightTheme() ? arborTheme : darkTheme;

export const useStyles = makeStyles((theme: any) => {
  const baseStyles = styles(currentTheme);

  return {
    summarySectionHeader: {
      ...(baseStyles.summarySectionHeader as any),
      color: isLightTheme() ? theme.palette.primary.steelGrey : theme.palette.primary.trellisBlue,
    },
    typographyTextSmall: {
      ...(baseStyles.typographyTextSmall as any),
    },
    phoneAvailableTimes: {
      ...(baseStyles.phoneAvailableTimes as any),
    },
    icon: {
      height: theme.spacing(2.0),
      paddingRight: theme.spacing(0.5),
    },
  };
});
